import React, { useState, useEffect } from 'react'
import '../pages/helpDesk/helpdesk.css'
import { Button, Form, Input } from 'antd';
import { message } from 'antd';
import axios from 'axios';
import key from '../key';
import logo from '../images/transLogo.svg'

const { TextArea } = Input;
const ContactUs = () => {
    const [email, setEmail] = useState('');
    //eslint-disable-next-line
    const [phone, setPhone] = useState('');
    //eslint-disable-next-line
    const [address, setAddress] = useState('');
    const getSiteSettings = async () => {
        await axios.get(`${key}/api/admin/get-site-settings`)
            .then((res) => {
                setEmail(res?.data?.setting?.email);
                setPhone(res?.data?.setting?.phone);
                setAddress(res?.data?.setting?.address);
            })
            .catch((err) => console.log(err));
    }
    const [form] = Form.useForm();

    const handleSubmit = async (values) => {
        try {
            await axios.post(`${key}/api/admin-email/create-email`, values)
            // console.log('Form values:', values);
            message.success('Form submitted successfully!');
            form.resetFields(); // Clear the form after successful submission
        } catch (error) {
            message.error("You can't send Message Right Now!");
        }
        // Handle form submission logic here, e.g., send the data to the server
    };

    const onFinishFailed = (errorInfo) => {
        message.error('Fill out all the fields');
    };
    useEffect(() => {

        getSiteSettings();
        //eslint-disable-next-line
    }, [])
    return (
        <div className='container helpDesk'>
            <div className="logo">
                <img src={logo} alt="lovodi" />
            </div>
            <div className='head'>Welcome to <span className='span'>Lovodi.com</span></div>
            <div className='backgroundLight'>
                <div className='d-flex justify-content-between'>

                    <div className=' subHead'>
                        <div className='d1'> Hello! <span> Users</span>, What's in your Mind?</div>
                        <div className='d2'>You can contact us by filling up this form.</div>
                        <div className='d3'>Thank You!</div>
                    </div>
                    <div className=' subHead'>
                        <div className='d1'>Email <span> {email}</span></div>
                    </div>
                </div>
                <div style={{ width: 600, margin: "0 auto" }}>
                    <div className='head'>Fill Out the Form<span className='span'></span></div>
                    <Form form={form} onFinish={handleSubmit} onFinishFailed={onFinishFailed}>
                        <Form.Item
                            name="name"
                            rules={[{ required: true, message: 'Please enter your name' }]}
                        >
                            <Input placeholder="Name" />
                        </Form.Item>

                        <Form.Item
                            name="email"
                            rules={[
                                { required: true, message: 'Please enter your email' },
                                { type: 'email', message: 'Please enter a valid email address' },
                            ]}
                        >
                            <Input placeholder="Email" />
                        </Form.Item>

                        <Form.Item
                            name="subject"
                            rules={[{ required: true, message: 'Please enter the subject' }]}
                        >
                            <Input placeholder="Subject" />
                        </Form.Item>

                        <Form.Item
                            name="message"
                            rules={[{ required: true, message: 'Please enter your message' }]}
                        >
                            <TextArea placeholder="Message" rows={4} />
                        </Form.Item>

                        <Button type="primary" htmlType="submit" className="send-button">
                            Send us
                        </Button>
                    </Form>
                </div>
            </div>
            <div className='mt-3'>.</div>
        </div>
    )
}

export default ContactUs
